export const __DEV__ = process.env.NODE_ENV !== 'production';
export const __STAGING__ =
  process.env.NEXT_PUBLIC_APPLICATION_ENV !== 'production';

/**
 * Check whether the current env is server, as opposed to browser
 * @returns whether the current env is server
 */
export const isServer = typeof window === 'undefined';

export const APPLICANT_BASE_URL =
  process.env.NEXT_PUBLIC_LELAND_APPLICANT_URL ?? '';
export const APPLICANT_LOGIN_URL = `${APPLICANT_BASE_URL}/login`;
export const APPLICANT_SIGNUP_URL = `${APPLICANT_BASE_URL}/signup`;

export const APPLICANT_SEARCH_URL = `${APPLICANT_BASE_URL}/search`;
export const APPLICANT_DASHBOARD_URL = `${APPLICANT_BASE_URL}/dashboard`;

export const FREE_MONTH_APPLY_URL = `${APPLICANT_BASE_URL}/freemonth/apply`;

export const COACH_BASE_URL =
  process.env.NEXT_PUBLIC_LELAND_COACH_URL ?? 'https://coach.joinleland.com';
export const COACH_SIGNUP_URL = `${APPLICANT_BASE_URL}/signup?coach=true`;

export const LIBRARY_BASE_URL = '/library';
export const LIBRARY_ARTICLE_BASE_URL = `${LIBRARY_BASE_URL}/a`;

export const EVENTS_BASE_URL = `${APPLICANT_BASE_URL}/events`;

export const SUPPORT_URL = 'https://intercom.help/leland-help-center';

export const LELAND_DOMAIN =
  __DEV__ || __STAGING__ ? '.leland-staging.com' : '.joinleland.com';

const BASE_LELAND_GO_URL = process.env.NEXT_PUBLIC_LELAND_GO_URL;

export const PARTNERSHIPS_LP_URL = `${BASE_LELAND_GO_URL}/partner/partnerships`;

export const BASE_LELAND_PLUS_MARKETING_URL = `${BASE_LELAND_GO_URL}/plus`;
export const LELAND_PLUS_REDIRECT_URL = `${APPLICANT_BASE_URL}/leland-plus`;

export const DEFERRED_MBA_SUBCATEGORY_SLUG = 'deferred-mba';

export const MBA_CATEGORY_SLUG = 'mba';
export const MANAGEMENT_CONSULTING_CATEGORY_SLUG = 'management-consulting';
export const COLLEGE_CATEGORY_SLUG = 'college';
export const GMAT_CATEGORY_SLUG = 'gmat';
export const GRE_CATEGORY_SLUG = 'gre';
export const PRODUCT_MANAGEMENT_CATEGORY_SLUG = 'product-management';
export const CAREER_CATEGORY_SLUG = 'career-development';
export const MEDICAL_SCHOOL_CATEGORY_SLUG = 'medical-school';
export const SUBSCRIBER_DUMMY_COACH_URN = 'urn:coach:60b2cb327b8ead4a78c16fc0';
export const MASTERS_PROGRAMS_CATEGORY_SLUG = 'masters-programs';
export const LAW_SCHOOL_CATEGORY_SLUG = 'law-school';
export const INVESTMENT_BANKING_CATEGORY_SLUG = 'investment-banking';
export const DENTAL_SCHOOL_CATEGORY_SLUG = 'dental-school';
export const PRIVATE_EQUITY_CATEGORY_SLUG = 'private-equity';
export const SOFTWARE_ENGINEERING_CATEGORY_SLUG = 'software-engineering';
export const BUSINESS_STRATEGY_AND_OPERATIONS_CATEGORY_SLUG =
  'business-strategy-and-operations';
export const SAT_CATEGORY_SLUG = 'sat';
export const ACT_CATEGORY_SLUG = 'act';
export const MCAT_CATEGORY_SLUG = 'mcat';

export const MBA_CATEGORY_ID = 'urn:category:mba';
export const MANAGEMENT_CONSULTING_CATEGORY_ID =
  'urn:category:management-consulting';
export const COLLEGE_CATEGORY_ID = 'urn:category:college';
export const GMAT_CATEGORY_ID = 'urn:category:gmat';
export const GRE_CATEGORY_ID = 'urn:category:gre';
export const PRODUCT_MANAGEMENT_CATEGORY_ID = 'urn:category:product-management';
export const CAREER_CATEGORY_ID = 'urn:category:career-development';
export const MEDICAL_SCHOOL_CATEGORY_ID = 'urn:category:medical-school';
export const MASTERS_PROGRAMS_CATEGORY_ID = 'urn:category:masters-programs';
export const LAW_SCHOOL_CATEGORY_ID = 'urn:category:law-school';
export const INVESTMENT_BANKING_CATEGORY_ID = 'urn:category:investment-banking';
export const DENTAL_SCHOOL_CATEGORY_ID = 'urn:category:dental-school';
export const PRIVATE_EQUITY_CATEGORY_ID = 'urn:category:private-equity';
export const SOFTWARE_ENGINEERING_CATEGORY_ID =
  'urn:category:software-engineering';
export const BUSINESS_STRATEGY_AND_OPERATIONS_CATEGORY_ID =
  'urn:category:business-strategy-and-operations';
export const SAT_CATEGORY_ID = 'urn:category:sat';
export const ACT_CATEGORY_ID = 'urn:category:act';
export const MCAT_CATEGORY_ID = 'urn:category:mcat';

export const CALENDLY_LINKS = {
  STRATEGY_CALL: 'https://calendly.com/d/zy6g-mpsk/leland-strategy-call',
  MEET_WITH_TEAM_MEMBER:
    'https://calendly.com/d/cpr6-m6z-yjh/meet-with-our-team',
};

export const GMAC_BOOTCAMP_TYPEFORM =
  'https://joinleland.typeform.com/gmacbootcamp50';

export const DEFAULT_ERROR_MESSAGE =
  'Something went wrong. Please try again. If the issue persists, contact Leland support at support@joinleland.com.';

// TODO - pull these numbers from BE
export const NUM_CUSTOMERS_STR = `250,000+`;
export const NUM_CATEGORIES_STR = '50+';

export const AVG_REVIEW_RATE = 4.98;

export const CLARITY_SESSION_ID_KEY = 'clarity_session_id';
export const HIDE_SUBSCRIBE_MODAL_KEY = 'hideSubscribeModal';
